import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LineGuidedtoursIcon from 'components/Luxkit/Icons/line/LineGuidedtoursIcon'
import LineStarIcon from 'components/Luxkit/Icons/line/LineStarIcon'
import LineCommentsAltIcon from 'components/Luxkit/Icons/line/LineCommentsAltIcon'
import LineBedQueenIcon from 'components/Luxkit/Icons/line/LineBedQueenIcon'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'
import Group from 'components/utils/Group'

const TourUSPSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(5, 260px);
  grid-auto-columns: 100%;
  gap: ${rem(24)};
  align-items: start;
  height: fit-content;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
  }
`

function TourUSPContainer() {
  return (
    <Group direction="vertical" gap={20}>
      <Heading variant="heading2">Luxury Escapes Tours give you <i>more</i></Heading>
      <TourUSPSection>
        <VerticalSpacer gap={8}>
          <LineStarIcon size="L" />
          <BodyText variant="medium" weight="bold">Exclusive tours, designed by our experts</BodyText>
          <BodyText variant="medium">
            Discover curated itineraries and handpicked experiences with tours designed by our team of travel experts.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineGuidedtoursIcon size="L" />
          <BodyText variant="medium" weight="bold">Immersive small-group adventures</BodyText>
          <BodyText variant="medium">
            Enjoy an intimate look at destinations across the globe with small-group journeys comprised of 24 travellers or less.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineUsersAltIcon size="L" />
          <BodyText variant="medium" weight="bold">Guaranteed two-person departures</BodyText>
          <BodyText variant="medium">
            Book your tour with confidence, knowing that we only require a minimum of two travellers to guarantee your departure.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineBedQueenIcon size="L" />
          <BodyText variant="medium" weight="bold">Exceptional quality at unbeatable value</BodyText>
          <BodyText variant="medium">
            Experience top-notch tours with 4 and 5-star accommodation and curated experiences that prioritise value without compromising on quality.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineCommentsAltIcon size="L" />
          <BodyText variant="medium" weight="bold">Dedicated tours concierge</BodyText>
          <BodyText variant="medium">
            From start to finish, our team is there with you, ensuring a seamless and exceptional experience from booking up until the end of your tour.
          </BodyText>
        </VerticalSpacer>
      </TourUSPSection>
    </Group>
  )
}

export default TourUSPContainer
